var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins } from 'vue-property-decorator';
import CanBase from '@/mixins/can/base';
var resource = 'member';
var CanMember = /** @class */ (function (_super) {
    __extends(CanMember, _super);
    function CanMember() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CanMember.prototype, "canIndexMember", {
        get: function () {
            var $Policies = this.$Policies;
            return $Policies.users.index;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanMember.prototype, "canCreateMember", {
        get: function () {
            return this.$can(resource, 'create');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanMember.prototype, "canUpdateMember", {
        get: function () {
            return this.$can(resource, 'update');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanMember.prototype, "canDeleteMember", {
        get: function () {
            return this.$can(resource, 'delete');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanMember.prototype, "canDeleteInvitationLink", {
        get: function () {
            return this.$can(resource, 'deleteInvitationLink');
        },
        enumerable: false,
        configurable: true
    });
    CanMember = __decorate([
        Component
    ], CanMember);
    return CanMember;
}(Mixins(CanBase)));
export default CanMember;
